import script from "./ProductsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsSection.vue?vue&type=script&setup=true&lang=js"

import "./ProductsSection.vue?vue&type=style&index=0&id=12cc2c52&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12cc2c52"]])

export default __exports__